import React from 'react';
import { motion } from 'framer-motion';
import { Ticket } from 'lucide-react';

const formatCurrency = (value, locale = 'es-AR') =>
  Number(value || 0).toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

const VentasDesgloseModal = ({ show, ventas, usuario, onClose }) => {
  if (!show) return null;

  const extrasActivos = ventas?.extrasDetalle?.activos ?? [];
  const extrasAnulados = ventas?.extrasDetalle?.anulados ?? [];
  const totales = ventas?.totales ?? {};
  const efectivoTotales = totales?.efectivo || { total: 0, entradas: 0, extras: 0 };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 pointer-events-auto">
      <motion.div className="bg-azul-oscuro rounded-xl p-6 w-[95vw] max-w-6xl max-h-[90vh] flex flex-col overflow-hidden">
        <h3 className="text-2xl font-bold text-amarillo-dorado mb-4">
          Desglose para rendición: {usuario?.nombre}
        </h3>

        <div className="mb-4 flex-1 overflow-auto">
          <div className="min-w-[1100px] space-y-2">
            <div className="grid grid-cols-12 gap-4 font-semibold bg-azul-oscuro bg-opacity-50 p-3 rounded-lg text-xs sm:text-sm md:text-base sticky top-0 z-10">
              <div>Medio de Pago</div>
              <div className="text-right">Entradas</div>
              <div className="text-right">Días</div>
              <div className="text-right">Entradas ($)</div>
              <div className="text-right">Monto</div>
              <div className="text-right">Extras</div>
              <div className="text-right">Cant. Extras</div>
              <div className="text-right text-red-300">Entradas Anuladas</div>
              <div className="text-right text-red-300">Días Anulados</div>
              <div className="text-right text-red-300">Monto Anulado</div>
              <div className="text-right text-red-300">Extras Anulados</div>
              <div className="text-right text-red-300">Cant. Extras Anulados</div>
            </div>

            {ventas.detalle?.length > 0 ? (
              <>
                {ventas.detalle.map((medio, index) => (
                  <motion.div
                    key={index}
                    className="grid grid-cols-12 gap-4 items-center p-3 hover:bg-blanco-puro hover:bg-opacity-5 rounded-lg transition-colors text-xs sm:text-sm md:text-base"
                  >
                    <div className="flex items-center">
                      <div className="w-3 h-3 rounded-full bg-verde-esmeralda mr-2"></div>
                      <span>{medio.nombre}</span>
                    </div>
                    <div className="text-right font-medium">
                      {medio.entradas || 0}
                    </div>
                    <div className="text-right font-medium">
                      {Number(medio.dias || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(medio.montoEntradas)}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(medio.monto)}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(medio.extras)}
                    </div>
                    <div className="text-right">
                      {Number(medio.extrasCantidad || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right font-medium text-red-300">
                      {medio.entradasAnuladas || 0}
                    </div>
                    <div className="text-right font-medium text-red-300">
                      {Number(medio.diasAnulados || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right font-bold text-red-300">
                      ${formatCurrency(medio.montoAnulado)}
                    </div>
                    <div className="text-right font-bold text-red-300">
                      ${formatCurrency(medio.extrasAnulados)}
                    </div>
                    <div className="text-right font-bold text-red-300">
                      {Number(medio.extrasCantidadAnulados || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                  </motion.div>
                ))}

                <div className="bg-azul-oscuro bg-opacity-50 rounded-lg p-4 mt-4 min-w-[1100px]">
                  <div className="grid grid-cols-12 gap-4 font-bold text-xs sm:text-sm md:text-base">
                    <div>Total a rendir</div>
                    <div className="text-right">{ventas.totales?.entradas || 0}</div>
                    <div className="text-right">
                      {Number(ventas.totales?.dias || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(ventas.totales?.montoEntradas || totales?.montoEntradas)}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(ventas.totales?.montoTotal)}
                    </div>
                    <div className="text-right">
                      ${formatCurrency(ventas.totales?.extras)}
                    </div>
                    <div className="text-right">
                      {Number(ventas.totales?.extrasCantidad || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right text-red-300">{ventas.totales?.entradasAnuladas || 0}</div>
                    <div className="text-right text-red-300">
                      {Number(ventas.totales?.diasAnulados || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                    <div className="text-right text-red-300">
                      ${formatCurrency(ventas.totales?.montoAnulado)}
                    </div>
                    <div className="text-right text-red-300">
                      ${formatCurrency(ventas.totales?.extrasAnulados)}
                    </div>
                    <div className="text-right text-red-300">
                      {Number(ventas.totales?.extrasCantidadAnulados || 0).toLocaleString("es-ES", { minimumFractionDigits: 0 })}
                    </div>
                  </div>
                </div>

                <div className="grid gap-4 md:grid-cols-2 mt-4">
                  <div className="bg-azul-oscuro bg-opacity-40 rounded-lg p-4">
                    <h4 className="text-lg font-semibold text-amarillo-dorado mb-2">Total en efectivo a rendir</h4>
                    <p className="text-xl font-bold">${formatCurrency(efectivoTotales.total)}</p>
                    <p className="text-sm text-gris-piedra mt-1">
                      Entradas: ${formatCurrency(efectivoTotales.entradas)}
                    </p>
                    <p className="text-sm text-gris-piedra">
                      Extras: ${formatCurrency(efectivoTotales.extras)}
                    </p>
                  </div>
                  <div className="bg-azul-oscuro bg-opacity-40 rounded-lg p-4">
                    <h4 className="text-lg font-semibold text-azul-claro mb-2">Total otros medios</h4>
                    <p className="text-xl font-bold">${formatCurrency(totales?.otrosMedios?.total)}</p>
                    <p className="text-sm text-gris-piedra mt-1">
                      Entradas: ${formatCurrency(totales?.otrosMedios?.entradas)}
                    </p>
                    <p className="text-sm text-gris-piedra">
                      Extras: ${formatCurrency(totales?.otrosMedios?.extras)}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center py-8">
                <Ticket className="w-12 h-12 text-gris-piedra mb-3" />
                <p className="text-gris-piedra text-center">
                  No se encontraron ventas registradas para este usuario
                </p>
              </div>
            )}
          </div>

          {(extrasActivos.length > 0 || extrasAnulados.length > 0) && (
            <div className="mt-6 bg-azul-oscuro bg-opacity-50 rounded-lg p-4">
              <h4 className="text-xl font-semibold text-azul-claro mb-3">Detalle de extras</h4>
              <div className="grid gap-4 md:grid-cols-2">
                {extrasActivos.length > 0 && (
                  <div>
                    <h5 className="text-lg font-semibold text-verde-esmeralda mb-2">Activos</h5>
                    <div className="space-y-2">
                      {extrasActivos.map((extra) => (
                        <div
                          key={`${extra.id ?? extra.nombre}-activo`}
                          className="flex justify-between text-sm md:text-base"
                        >
                          <span>{extra.nombre}</span>
                          <span className="font-semibold text-amarillo-dorado">
                            {`${Number(extra.cantidad || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })} uds · $${formatCurrency(extra.total)}`}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {extrasAnulados.length > 0 && (
                  <div>
                    <h5 className="text-lg font-semibold text-red-300 mb-2">Anulados</h5>
                    <div className="space-y-2">
                      {extrasAnulados.map((extra) => (
                        <div
                          key={`${extra.id ?? extra.nombre}-anulado`}
                          className="flex justify-between text-sm md:text-base text-red-200"
                        >
                          <span>{extra.nombre}</span>
                          <span className="font-semibold">
                            {`${Number(extra.cantidad || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })} uds · $${formatCurrency(extra.total)}`}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="flex justify-end border-t border-gris-piedra border-opacity-20 pt-4">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-amarillo-dorado hover:bg-amber-500 text-azul-oscuro rounded-lg font-medium"
            >
              Cerrar
            </button>
          </div>
        </div> 

      </motion.div>
    </div>
  );
};

export default VentasDesgloseModal;
